var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationOrangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.062,12.465a4.972,4.972,0,1,0,4.972,4.972A4.979,4.979,0,0,0,33.062,12.465Zm0,7.458a2.486,2.486,0,1,1,2.486-2.486A2.489,2.489,0,0,1,33.062,19.923Zm6.821,7.753c2.289-3.538,4.366-7.5,4.366-10.239a11.109,11.109,0,0,0-2.015-6.406A1.243,1.243,0,0,0,40.2,12.456a8.637,8.637,0,0,1,1.566,4.981c0,3.707-5.608,11.535-8.7,15.431-3.094-3.9-8.7-11.723-8.7-15.431A8.7,8.7,0,0,1,37.4,9.891a1.243,1.243,0,1,0,1.24-2.155,11.191,11.191,0,0,0-16.762,9.7c0,2.744,2.074,6.7,4.363,10.235-2.721,1.388-4.363,3.564-4.363,5.925,0,4.181,4.913,7.458,11.187,7.458S44.249,37.778,44.249,33.6c0-2.371-1.644-4.534-4.366-5.92ZM33.062,38.569c-4.717,0-8.7-2.276-8.7-4.972,0-1.471,1.231-2.9,3.269-3.849,2.079,2.982,4.029,5.351,4.478,5.889a1.243,1.243,0,0,0,1.908,0c.449-.538,2.4-2.907,4.476-5.887,2.04.951,3.271,2.366,3.271,3.847,0,2.7-3.986,4.972-8.7,4.972Z",
    transform: "translate(-21.874 -6.25)",
    fill: "#ea6d03"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOrangeIcon);
export default __webpack_public_path__ + "static/media/location-orange-icon.81d0b40aefdd8349da8b8dae102b5185.svg";
export { ForwardRef as ReactComponent };